export const avaliations = [
  {
    value: 1,
    label: 'Avaliação de Novos Projetos',
    href: 'evaluation/project/',
  },
  {
    value: 2,
    label: 'Avaliação de Legítimo Interesse',
    href: 'ali/',
  },
  {
    value: 4,
    label: 'Avaliação de Terceiros',
    href: 'tpa/',
  },
  {
    value: 5,
    label: 'Registro de Operação de Tratamento de Dados',
    href: 'ropa/',
  },
];
